import { createContext, useContext } from 'react';
import { ILanguageItem, ISupportedLanguages } from 'models';

export const SupportedLanguagesContext = createContext<{
  languageOptions: ILanguageItem[];
  supportedLanguages: ISupportedLanguages;
}>({
  languageOptions: {} as ILanguageItem[],
  supportedLanguages: {} as ISupportedLanguages,
});

export const useSupportedLanguagesContext = () => useContext(SupportedLanguagesContext);
